import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=64b1ae72&scoped=true"
import script from "./ReportList.vue?vue&type=script&lang=js"
export * from "./ReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b1ae72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b1ae72')) {
      api.createRecord('64b1ae72', component.options)
    } else {
      api.reload('64b1ae72', component.options)
    }
    module.hot.accept("./ReportList.vue?vue&type=template&id=64b1ae72&scoped=true", function () {
      api.rerender('64b1ae72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Report/ReportList.vue"
export default component.exports